var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tooltip)?_c('tooltip',{attrs:{"id":_vm.tooltip.id,"label":_vm.tooltip.label}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }